import "./smallModal.css";
import IconAlert from "../../../assets/svgs/icon-alert.svg";
import { useState, useEffect } from "react";
import ContainerErrorSmall from "../../error/containerError";
import Input from "../../fluxo-engenheiro/formBasic/Input";
import maskFormat from "../../../utils/maskFormat";
import { ModalButtons } from "../../ModalButtons/modalButtons";
import { ModalInputMotivo } from "../../ModalMotivo/ModalInputMotivo";
import { useRoles } from "../../../hooks/roles";
interface SmallModalProps {
  titleModal?: string;
  titleDescription?: React.ReactNode;
  bodyModal?: React.ReactNode;
  buttonOne?: string;
  titleLabel?: string;
  buttonTwo?: string;
  inputMotivo?: string;
  inputNCM?: string;
  buttonThree?: string;
  onLogout?: () => void;
  onClose?: () => void;
  onConfirm?: () => void;
  className?: string;
  ncmCode?: string;
  commentText?: string;
  setCommentText?: (text: string) => void;
  setNcmCode?: (text: string) => void;
  isButtonDisabled?: boolean;
  onDisableButton?: (disabled: boolean) => void;
  isSubmitting?: boolean;
  ncmError?: string | null;
  setNcmError?: (error: string | null) => void;
}

export const SmallModal = ({
  titleModal,
  titleDescription,
  bodyModal,
  titleLabel,
  buttonOne,
  buttonTwo,
  inputMotivo,
  inputNCM,
  buttonThree,
  onClose,
  onConfirm,
  onLogout,
  className,
  ncmCode,
  commentText,
  setCommentText,
  setNcmCode,
  isButtonDisabled,
  onDisableButton,
  isSubmitting,
  ncmError,
  setNcmError,
}: SmallModalProps) => {
  const [motivoError, setMotivoError] = useState("");
  const [ncmMessagerError] = useState("");
  const [motivoNumber, setMotivoNumber] = useState(commentText || "");
  const [ncmNumber, setNCMNumber] = useState(ncmCode || "");
  const MAX_LENGTH_MOTIVO = 500;
  const NCM_LENGTH = 8;

  const [showNcmError, setShowNcmError] = useState(!!ncmError);

  const { isTax } = useRoles();

  useEffect(() => {
    setMotivoNumber(commentText || "");
    setNCMNumber(ncmCode || "");
  }, [commentText, ncmCode]);

  useEffect(() => {
    setShowNcmError(!!ncmError);
  }, [ncmError]);

  useEffect(() => {
    if (onDisableButton) {
      const isMotivoValid =
        motivoNumber.length > 0 && motivoNumber.length <= MAX_LENGTH_MOTIVO;

      const cleanedNcmNumber = ncmNumber.replaceAll(/\D/g, "");
      const isNcmValid = cleanedNcmNumber.length === NCM_LENGTH;

      isTax
        ? onDisableButton(
            !(isMotivoValid && isNcmValid) ||
              ncmMessagerError !== "" ||
              !!ncmError
          )
        : onDisableButton(!isMotivoValid);
    }
  }, [motivoNumber, ncmNumber, onDisableButton, ncmMessagerError, ncmError]);

  const handleNCMChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setNCMNumber(value);
    if (setNcmCode) {
      setNcmCode(value);
    }
    if (showNcmError) {
      setShowNcmError(false);
      if (setNcmError) {
        setNcmError("");
      }
    }
  };

  const setMotivoValue = (newValue: string) => {
    if (newValue.length >= MAX_LENGTH_MOTIVO) {
      setMotivoError("Limite de 500 caracteres atingido.");
    } else {
      setMotivoError("");
    }
    setMotivoNumber(newValue);

    if (setCommentText && newValue.length <= MAX_LENGTH_MOTIVO) {
      setCommentText(newValue);
    }
  };

  return (
    <div className={`smallModalCorporateSession ${className}`}>
      <div className="smallModal">
        <div>
          <div className="containerTitleSmallModal">
            {titleModal && <h1 className="titleSmallModal">{titleModal}</h1>}
          </div>
          <div className="containerDescription">
            {titleDescription && (
              <span className="bodySmallModal">{titleDescription}</span>
            )}

            {bodyModal && (
              <span className="bodySmallModal" id="bodyModalStyle">
                {bodyModal}
              </span>
            )}

            <ModalInputMotivo
              inputMotivo={inputMotivo === "sim"}
              titleLabel={titleLabel}
              value={motivoNumber}
              setValue={setMotivoValue}
              errorMessage={motivoError}
              marginTop={50}
              width="34.6ch"
            />

            {inputNCM && isTax && (
              <div style={{ marginTop: 35 }}>
                <span>Informe a NCM correta</span>
                <div style={{ paddingBottom: "25px" }}>
                  <Input
                    id="material-part-desc"
                    label=""
                    placeholder="Exemplo: 0000.00.00"
                    value={ncmNumber}
                    onChange={handleNCMChange}
                    maskFunction={maskFormat.maskCharacterNcm}
                    applyMask={true}
                    aria-describedby="NCM"
                    width={"39.3ch"}
                  />

                  {showNcmError && (
                    <ContainerErrorSmall
                      id="material-part-corrigir-error containerErroSmall"
                      label={ncmError || ''}
                      icon={IconAlert}
                      backgroudError={"#FFD9D9"}
                      widthError=""
                      colorError={"#000000"}
                    />
                  )}
                </div>
              </div>
            )}

            <ModalButtons
              buttonOne={buttonOne}
              buttonTwo={buttonTwo}
              buttonThree={buttonThree}
              onConfirm={onConfirm}
              onClose={onClose}
              onLogout={onLogout}
              isButtonDisabled={isButtonDisabled}
              isSubmitting={isSubmitting}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmallModal;
